import {
  CartIppicaScommessaAvvenimento,
  CartScommessaAvvenimentoVirtual,
  MovimentiTipoScommessaEnum,
} from 'types/swagger';

import { SportTicketAvvenimento } from 'features/sport/components/sportTicket/utils/calcoloCarrello/types';
import { ippicaTicketSlice } from 'features/ippica/components/ippicaTicket/ippicaTicketSlice';
import { sportTicketSlice } from 'features/sport/components/sportTicket/sportTicketSlice';
import { virtualTicketSlice } from 'features/virtual/components/virtualTicket/virtualTicketSlice';

export const formatPrice = (price: string) => {
  const options: Intl.NumberFormatOptions = {
    style: 'decimal',
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  const value = parseFloat(price);
  return (isNaN(value) ? 0 : value).toLocaleString('it-IT', options);
};

export const removeLeadingZeros = (value: string): string => {
  // // Se il valore è solo una virgola, aggiungi lo zero davanti (es: "," -> "0,")
  if (value.startsWith('.')) {
    value = `0${value}`;
  }

  // Se il valore inizia con più zeri seguiti da un numero (es: 0005 -> 5)
  value = value.replace(/^0+(?=\d)/, '');

  // Se il valore inizia con più zeri prima della virgola (es: 00,5 -> 0,5)
  value = value.replace(/^0+(?=,)/, '0');

  return value;
};

export const getSliceByTipoTicket = (
  tipo: MovimentiTipoScommessaEnum
): typeof virtualTicketSlice | typeof sportTicketSlice | typeof ippicaTicketSlice => {
  switch (tipo) {
    case MovimentiTipoScommessaEnum.Sport:
      return sportTicketSlice;
    case MovimentiTipoScommessaEnum.Ippica:
      return ippicaTicketSlice;
    default:
      return virtualTicketSlice;
  }
};

export const formatValueByDivisor = (num: number, divisor: number): number => {
  return num / divisor;
};

export const isCarrelloTypeSport = (type: MovimentiTipoScommessaEnum) => {
  return type === MovimentiTipoScommessaEnum.Sport;
};

export const isCarrelloTypeVirtual = (type: MovimentiTipoScommessaEnum) => {
  return type === MovimentiTipoScommessaEnum.Virtual;
};

export const isCarrelloTypeIppica = (type: MovimentiTipoScommessaEnum) => {
  return type === MovimentiTipoScommessaEnum.Ippica;
};

export const isAvvenimentiIppica = (
  avvenimenti: SportTicketAvvenimento[] | CartScommessaAvvenimentoVirtual[] | CartIppicaScommessaAvvenimento[]
): avvenimenti is CartIppicaScommessaAvvenimento[] => {
  return avvenimenti.every((avvenimento) => avvenimento['descrizioneAvvenimento']);
};
